
// const validateCategoryIds = (rule, value, callback) => {
//     if (value.length === 0) {
//         callback(new Error('请选择类目'));
//     } else {
//         callback();
//     }
// }
const validateTitle = (rule, value, callback) => {
    const regx = /^\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F]$/;
    if (regx.test(value)) {
        callback(new Error('不能含emoj表情'));
    } else {
        // 计算字节长度：中文字符占2个字节，英文和数字占1个字节
        let byteLength = 0;
        for (let i = 0; i < value.length; i++) {
            const char = value.charAt(i);
            // 判断是否为中文字符（包括中文标点符号）
            if (/[\u4e00-\u9fa5\u3000-\u303f\uff00-\uffef]/.test(char)) {
                byteLength += 2;
            } else {
                byteLength += 1;
            }
        }
        if (byteLength > 100) {
            callback(new Error('最多100个字节（中文字符占2个字节，英文和数字占1个字节）'));
        } else {
            callback();
        }
    }
}
const validOuterId = (rule, value, callback, context) => {
    if (!value) {
      callback(new Error('请填写款式编码'));
    } else {
      callback()
    }
  }
const validateDescrip = (rule, value, callback) => {
    const regx = /^\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F]$/;
    if (value) {
        if (regx.test(value)) {
            callback(new Error('不能含emoj表情'));
        } else if (value.length < 8 || value.length > 50) {
            callback(new Error('必须为8-50个汉字'))
        } else {
            callback();
        }
    } else {
        callback();
    }
    
}
const validateImageUrls = (rule, value, callback) => {
    let sum = 0;
    if (value.length) {
        value.forEach(v => {
            if (v) sum++;
        })
    }
    if (value.length < 1 || sum === 0) {
        callback(new Error('至少要选择1张图片'));
    } else {
        callback()
    }
    
}
const validatePic34 = async (rule, value, callback, context) => {
    if(context.$refs.mainImages34){
        let errMsg = await context.$refs.mainImages34.method_validImage()
        if (errMsg) {
            callback(new Error(errMsg));
        } else {
            callback();
        }
    } else {
        callback();
    }
}
const validateWhiteBackGroundPic = async (rule, value, callback, context) => {
    if(context.$refs.mainImages34){
        let errMsg = await context.$refs.whiteBackGroundPic.method_validImage()
        if (errMsg) {
            callback(new Error(errMsg));
        } else {
            callback();
        }
    } else {
        callback();
    }
}
const validatePrice = (rule, value, callback) => {
    const valueNum = Number(value);
    const idx = value.lastIndexOf('.');
    const mStr = value.slice(idx+1);
    if (isNaN(valueNum)) {
        callback(new Error('必须为大于等于0的正数且支持小数点后2位'));
    } else if (valueNum < 0) {
        callback(new Error('必须为大于等于0的正数且支持小数点后2位'));
    } else if (idx !== -1 &&  mStr.length > 2) {
        callback(new Error('必须为大于等于0的正数且支持小数点后2位'));
    } else {
        callback();
    }
}
const validateWeight = (rule, value, callback) => {
    const valueNum = Number(value);
    const idx = value.lastIndexOf('.');
    const mStr = value.slice(idx+1);
    if (isNaN(valueNum)) {
        callback(new Error('必须为大于等于0的正数且支持小数点后4位'));
    } else if (valueNum < 0) {
        callback(new Error('必须为大于等于0的正数且支持小数点后4位'));
    } else if (idx !== -1 && mStr.length > 4) {
        callback(new Error('必须为大于等于0的正数且支持小数点后4位'));
    } else {
        callback();
    }
    
}
const validateKefuPhone = (rule, value, callback) => {
    const regx = /^[0-9-]+$/
    if (!regx.test(value)) {
        callback(new Error('仅支持数字和-，不允许超过32个字符'));
    } else {
        callback();
    }
    
}

const validateDistribution = (rule, value, callback) => {
    if (value > 0) {
        callback()
    } else {
        callback(new Error('是否加入分销小店'))
    }
}

// 若需要vm上下文请用此函数包裹
function contextWrap(fn, context) {
    return (rule, value, callback) => fn(rule, value, callback, context);
}

const RULES = function(context) {
    return {
        // categoryIds: [
        //     {required: true, message: '请选择类目'},
        //     {validator: validateCategoryIds}
        // ],
        outerId: [
            {required: true, message: '请填写款式编码'},
            { validator: contextWrap(validOuterId, context)}
        ],
        title: [
            {required: true, message: '请填写商品名称'},
            {validator: validateTitle}
        ],
        mainImages: [
            {required: true, message: '至少选择1张图片'},
            {validator: validateImageUrls}
        ],
        mainImages34:[
            {required: false, message: ''},
            {validator: contextWrap(validatePic34, context), trigger: 'change'},
        ],
        whiteBackGroundPic:[
            {validator: contextWrap(validateWhiteBackGroundPic, context), trigger: 'change'},
        ],
        isPrivacyDistributionState: [
            {required: true, message: '请选择分销状态'},
            {validator: validateDistribution}
        ]
    };
};

export default RULES;